export const KESHET_VOTING_HOSTNAME = 'keshet12vote.mako.co.il';
export const STORYCARDS_VOTING_HOSTNAME = 'vote.storycards.app';

const KESHET_VOTING_METADATA = {
  title: 'Keshet12 Vote',
  description: 'LIVE Voting application',
};

const STORYCARDS_VOTING_METADATA = {
  title: 'Storycards Votes',
  description: 'Storycards Votes',
};

const productionVotingHostnames = [KESHET_VOTING_HOSTNAME, STORYCARDS_VOTING_HOSTNAME];

export const getVotingHostname = (organization?: string) =>
  organization === 'storycards' ? STORYCARDS_VOTING_HOSTNAME : KESHET_VOTING_HOSTNAME;

export const getVotingMetadata = (hostname: string) =>
  hostname === STORYCARDS_VOTING_HOSTNAME ? STORYCARDS_VOTING_METADATA : KESHET_VOTING_METADATA;

export const getCanonicalVotingUrl = (organization: string | undefined, currentHref: string) => {
  const currentUrl = new URL(currentHref);
  if (!productionVotingHostnames.includes(currentUrl.hostname)) return null;

  const canonicalHostname = getVotingHostname(organization);
  if (currentUrl.hostname === canonicalHostname) return null;

  currentUrl.protocol = 'https:';
  currentUrl.hostname = canonicalHostname;
  currentUrl.port = '';
  return currentUrl.toString();
};
